export function leadInLogoGospelMeeting(title, subtitle, image) {
    return `
        <div class="gospel-meeting-content">
            <div class="content">
                <h1 class="main-title">
                    <span class="fragment title" data-autoslide="250" data-fragment-index="0">Learning</span>
                    <em class="fragment title" data-fragment-index="1" data-autoslide="250">Prayer</em>
                </h1>
                <div class="r-stack images">
                    ${image}
                </div>
                <div class="r-stack fragment date" data-fragment-index="0">${title}</div>
                <div class="r-stack lead-presenter">${subtitle}</div>
            </div>
        </div>
    `;
}
